import { QBox } from '@qualio/ui-components';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Page } from 'react-pdf';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';

const RENDER_ROOT_MARGIN = '1000px 0px';

const LazyPage = ({
  pageNumber,
  width,
  height,
  zoom,
}: {
  pageNumber: number;
  width: number | undefined;
  height: number;
  zoom: number;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isVisible = useIntersectionObserver(containerRef, {
    rootMargin: RENDER_ROOT_MARGIN,
  });

  return (
    <QBox ref={containerRef} style={{ minHeight: height }}>
      {isVisible && (
        <Page
          pageNumber={pageNumber}
          renderAnnotationLayer={false}
          renderTextLayer={false}
          width={width}
          height={height}
          scale={zoom}
        />
      )}
    </QBox>
  );
};

export interface PDFPageProps {
  width: number | undefined;
  height: number;
  isPaginated: boolean;
  zoom: number;
  pageNumber: number;
  pageCount: number;
}

export const PDFPage = ({
  width,
  height,
  isPaginated,
  pageNumber,
  pageCount,
  zoom,
}: PDFPageProps) => {
  const [isRendered, setIsRrendered] = useState<boolean>(false);
  const canvasRef = useRef<HTMLElement>();

  const handleRenderSucces = () => {
    setIsRrendered(true);
  };

  useEffect(() => {
    if (canvasRef.current) {
      const documentElement = document.querySelector(
        '.react-pdf__Document',
      ) as HTMLElement;
      if (documentElement) {
        documentElement.style.height = `${canvasRef.current.clientHeight}px`;
      }
    }
  }, [isRendered]);

  useMemo(() => {
    const documentElement = document.querySelector(
      '.react-pdf__Document',
    ) as HTMLElement;
    documentElement.style.height = '';
    // eslint-disable-next-line
  }, [isPaginated]);

  if (!isPaginated) {
    return (
      <QBox
        style={{
          maxWidth: '100%',
          transformOrigin: 'top left',
        }}
      >
        <>
          {Array.from(new Array(pageCount)).map((_, idx) => (
            <LazyPage
              key={`page-${idx}`}
              pageNumber={idx + 1}
              width={width}
              height={height}
              zoom={zoom}
            />
          ))}
        </>
      </QBox>
    );
  }

  return (
    <QBox
      style={{
        maxWidth: width,
        transformOrigin: 'top left',
      }}
    >
      <Page
        // eslint-disable-next-line
        // @ts-ignore
        canvasRef={canvasRef}
        pageNumber={pageNumber}
        renderAnnotationLayer={false}
        renderTextLayer={false}
        onRenderSuccess={handleRenderSucces}
        scale={zoom}
      />
    </QBox>
  );
};
